import iban from 'iban'

export default {
  validate(value) {
    return iban.isValid(value)
  },
  computesRequired: true
}
